<template>
  <div class="home">
    <van-swipe class="my-swipe" :autoplay="3000">
      <van-swipe-item><img src="../assets/image/title.png" alt=""></van-swipe-item>
      <van-swipe-item><img src="../assets/image/banner.png" alt=""></van-swipe-item>
    </van-swipe>
    <img src="../assets/image/zizhi.png"/>
    <div class="check">
      <div class="inner">
        <p>{{ form.name}}</p>
        <a href="http://apis.map.qq.com/tools/poimarker?type=0&amp;marker=coord:28.217222,112.873691&amp;name=长沙三济医学检验实验室&amp;addr=湖南省长沙市岳麓区麓谷国际工业园a5栋&amp;key=OAEBZ-PWKWW-LD4RZ-OCLFD-U52CJ-X6BQT&amp;referer=myapp;"><img
            src="../assets/image/position.png" alt="">{{ form.addr }}</a>
        <a class="timeShow">
          <van-icon name="clock-o" class="time"/>
          {{ form.workTime}} {{ form.am}} {{ form.pm}}</a>
        <li><img src="../assets/image/tel.png" alt=""><a style="margin-right: 10px" href="tel:0731-89824899">0731-89824899</a><a href="tel:18007319269">18007319269</a></li>
        <span class="price">¥<a style="text-decoration: none">{{ form.money }}</a>元/人 </span>
      </div>
<!--      2021年2月26号暂停预约服务 如需开启 加上点击事件 @click="login"-->
      <button class="moment">暂停预约</button>
    </div>
    <div class="company">
      <img src="../assets/image/com.jpg" alt="">
      <p>长沙三济医学检验实验室是国内从事精准医疗研发和服务的个体化医学实验室之一，是经国家卫生行政部门批准执业的一家专注于分子诊断的医学检验机构，拥有通过卫生部临检中心临床基因扩增检验技术验收的专业基因检测实验室。</p>
    </div>
    <img src="../assets/image/connect.png"/>
    <p class="explain">最终解释权归长沙三济生物科技有限公司所有</p>
  </div>
</template>
<script>
import {getInfo} from '@/api/order/index.js';
export default {
  name: 'Home',
  data() {
    return {
      form: {
        money:'',
        addr:'',
        name:'',
        pm:'',
        am:'',
        workTime:'',
        telephones:''
      }

    };
  },
  created() {
    this.getList();
    // this.getAuthor()
  },
  methods: {
    login() {
      const url=window.location.href
      const openId=url.split('=')[1].split('#')[0]
      console.log(url);
      console.log(openId);
      if(openId){
        this.$router.push({path: 'about', query: {id: this.form.id,openId}});
      }else{
        this.$toast('网络繁忙，请刷新后重试!');
      }
    },
    getList() {
      const data = {
        id: this.form.id,
      };
      getInfo(data).then(res => {
        console.log(res);
        this.form = res.data.data[0];
        console.log(this.form.id);
        console.log(this.form.money);
      });

    },
    //获取授权
  //   getAuthor(){
  //     getAuthorization().then(res => {
  //       console.log(res);
  //     });
  //   }
  }
};
</script>
<style scoped lang='less'>
page {
  margin: 0;
  padding: 0;
  //width: 350px;
  a {
    color: black;
  }

}

.home {
  width: 750px;
  //height: 750px;
  background: linear-gradient(to right, #1343CF, #0C7FD8);
  padding-bottom: 10px;
}

img {
  width: 100%;
}

.check {
  margin: 0 auto;
  width: 690px;
  background-color: #fff;
  padding: 20px ;
  box-sizing: border-box;
  border-radius: 20px;
  .inner {
    display: flex;
    flex-direction: column;
    padding-left: 30px;
    justify-content: space-between;

    img {
      width: 26px;
      margin-right: 15px;
    }

    a {
      font-size: 26px;
      color: #333333;
      margin: 10px 0;
      text-decoration: underline;
    }
    .timeShow{
      text-decoration: none;
    }

    .price {
      color: #F83F33;
      font-weight: 600;
      font-size: 35px;
      margin: 10px 0;

      a {
        color: #F83F33;
        font-size: 75px;
        margin: 0 5px;
      }
    }


  }
  button {
    width: 580px;
    margin-left:25px;
    height: 80px;
    border: none;
    background-color: RBG(224,224,224);
    border-radius: 50px;
    color: #666;
    font-size: 40px;
    //font-weight: bold;
  }
  p {
    font-size: 56px;
    color: #2985E8;
    font-weight: 600;
    margin: 20px 0;
  }

  img {
    width: 14px;
  }

  a {
    font-size: 14px;
    color: black;
    text-decoration: none;

  }
}

.company {
  margin: 0 auto;
  width: 690px;
  border-radius: 20px;
  background-color: #fff;
  padding-bottom: 20px;
  margin-top: 20px;

  img {
    width: 675px;
    margin: 10px;
  }

  p {
    width: 631px;
    margin: 0 auto;
    font-size: 30px;
    color: #333333;
    margin-bottom: 20px;
  }
}

.explain {
  margin: 10px auto;
  color: #fff;
  font-size: 28px;
  width: 100%;
  text-align: center;
}
.time {
  color: #48BB9C;
  font-weight: bold;
  margin-right: 7px;
}
li{
  list-style: none;
  margin-top: 5px;
}
</style>
